'use client'

import { YandexMetricaProvider } from 'next-yandex-metrica'

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <YandexMetricaProvider
      tagID={101819102}
      initParameters={{
        clickmap: true,
        trackLinks: true,
        accurateTrackBounce: true,
        webvisor: true,
      }}
    >
      {children}
    </YandexMetricaProvider>
  )
}
